export const loadGTM = () => {
  if (window.gtmLoaded) return;

  window.gtmLoaded = true;
  window.dataLayer = window.dataLayer || [];

  const script = document.createElement("script");
  script.async = true;
  script.src =
    "https://www.googletagmanager.com/gtm.js?id=GTM-MG4VH7GP";

  document.head.appendChild(script);
};
export const loadFacebookPixel = () => {
  if (window.fbPixelLoaded) return;

  window.fbPixelLoaded = true;

  (function(f,b,e,v,n,t,s)
  {
    if(f.fbq) return;

    n=f.fbq=function(){
      n.callMethod ?
      n.callMethod.apply(n,arguments) :
      n.queue.push(arguments);
    };

    if(!f._fbq) f._fbq=n;

    n.push=n;
    n.loaded=true;
    n.version='2.0';
    n.queue=[];

    t=b.createElement(e);
    t.async=true;
    t.src=v;

    s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s);

  })(window, document, 'script',
     'https://connect.facebook.net/en_US/fbevents.js');

  window.fbq('init', '727073183611568');
  window.fbq('track', 'PageView');
};
// export const loadFacebookPixel = () => {
//   if (window.fbPixelLoaded) return;

//   window.fbPixelLoaded = true;

//   const script = document.createElement("script");
//   script.async = true;
//   script.src = "https://connect.facebook.net/en_US/fbevents.js";

//   script.onload = () => {
//     if (!window.fbq) return;

//     window.fbq("init", "727073183611568");
//     window.fbq("track", "PageView");
//   };

//   document.head.appendChild(script);

//   window.fbq =
//     window.fbq ||
//     function () {
//       (window.fbq.q = window.fbq.q || []).push(arguments);
//     };
// };
// export const loadFacebookPixel = () => {
//   if (window.fbPixelLoaded) return;

//   window.fbPixelLoaded = true;

//   !(function (f, b, e, v, n, t, s) {
//     if (f.fbq) return;

//     n = f.fbq = function () {
//       n.callMethod
//         ? n.callMethod.apply(n, arguments)
//         : n.queue.push(arguments);
//     };

//     if (!f._fbq) f._fbq = n;

//     n.push = n;
//     n.loaded = true;
//     n.version = "2.0";
//     n.queue = [];

//     t = b.createElement(e);
//     t.async = true;
//     t.src = v;

//     s = b.getElementsByTagName(e)[0];
//     s.parentNode.insertBefore(t, s);
//   })(
//     window,
//     document,
//     "script",
//     "https://connect.facebook.net/en_US/fbevents.js"
//   );

//   window.fbq("init", "727073183611568");
//   window.fbq("track", "PageView");
// };

export const loadTrackingScripts = () => {
  loadGTM();
  loadFacebookPixel();
};